import { useQuery } from "@tanstack/react-query";
import client from "./client";
import type { ComplianceData, GlobalComplianceItem, GlobalComplianceTiers } from "./types";

export function useTenantCompliance(tenantId: string) {
  return useQuery<ComplianceData>({
    queryKey: ["compliance", tenantId],
    queryFn: async () => {
      const { data } = await client.get(`/tenants/${tenantId}/compliance/`);
      return data.data;
    },
    enabled: !!tenantId,
  });
}

export function useGlobalCompliance() {
  return useQuery<GlobalComplianceItem[]>({
    queryKey: ["compliance", "global"],
    queryFn: async () => {
      const { data } = await client.get("/compliance/global");
      return data.data;
    },
  });
}

export function useGlobalComplianceTiers() {
  return useQuery<GlobalComplianceTiers>({
    queryKey: ["compliance", "global", "tiers"],
    queryFn: async () => {
      const { data } = await client.get("/compliance/global/tiers");
      return data.data;
    },
  });
}
